import React, { useState, useRef } from 'react';
import video3 from '../assets/videos/Dinshaw Knowledge Final.mp4';
import video1 from '../assets/videos/Dinshaw Purity Final.mp4';
import video2 from '../assets/videos/Dinshaw Technology Final.mp4';
import video4 from '../assets/videos/1088048885-preview.mp4';
import VideoPlayer from './VideoPlayer';
import VideoPlayerOverlay from './VideoPlayerOverlay';

const VideoGridDesktop = () => {

    const [showOverlay, setShowOverlay] = useState(true);

    const videoElement1 = useRef(null);
    const videoElement2 = useRef(null);
    const videoElement3 = useRef(null);
    const videoElement4 = useRef(null);

    const elementsArr = [videoElement1, videoElement2, videoElement3, videoElement4];

    const handleVideoPlay = (element, action) => {
        if (action === 'play') {
            elementsArr.forEach(el => {
                if (el.current.src !== element.current.src) {
                    el.current.style.display = 'none';
                }
            });
            element.current.style.display = 'block';
            element.current.volume = 0.05;
            
            element.current.play();
        } else {
            element.current.pause();
            element.current.style.display = 'none';
        }
    }

    const handleContainerLeave = () => {
        setShowOverlay(true);
    }

    const handleContainerEnter = () => {
        setShowOverlay(false);
        elementsArr.forEach(el => {
            el.current.style.display = 'none';
        });
    }

    return (
        <div className='video-overlay relative' onMouseLeave={handleContainerLeave} onMouseEnter={handleContainerEnter}>
            <VideoPlayer videoRef={videoElement1} videoSrc={video1} />
            <VideoPlayer videoRef={videoElement2} videoSrc={video2} />
            <VideoPlayer videoRef={videoElement3} videoSrc={video3} />
            <VideoPlayer videoRef={videoElement4} videoSrc={video4} />
            <div className="absolute top-0 h-full w-full grid grid-cols-2 video-overlay z-10">
                <VideoPlayerOverlay handleVideoPlay={handleVideoPlay} element={videoElement1} showOverlay={showOverlay} thumbnailSrc="/assets/static/images/Video1-thumbnail.JPG"></VideoPlayerOverlay>
                <VideoPlayerOverlay handleVideoPlay={handleVideoPlay} element={videoElement2} showOverlay={showOverlay} thumbnailSrc="/assets/static/images/Video2-thumbnail.JPG"></VideoPlayerOverlay>
                <VideoPlayerOverlay handleVideoPlay={handleVideoPlay} element={videoElement3} showOverlay={showOverlay} thumbnailSrc="/assets/static/images/Video3-thumbnail.JPG"></VideoPlayerOverlay>
                <VideoPlayerOverlay handleVideoPlay={handleVideoPlay} element={videoElement4} showOverlay={showOverlay} thumbnailSrc="/assets/static/images/Video4-thumbnail.JPG"></VideoPlayerOverlay>
            </div>
        </div>
    )
};

export default VideoGridDesktop;